
(function() {
    
    let tlFreeGiftOfferClone;
    let embedWidgetClone ;

    const getTargetEl = () => {
        const widgetSelector = ".salepify-embed-widget-placement, .salepify-embed-widget-block";
        const widgetElements = document.querySelectorAll(widgetSelector);

        if (widgetElements.length) return widgetElements;

        const defaultSelector = `gp-product-button.gp-product-button`; // modify here
        const fallbackElement = document.querySelectorAll(defaultSelector);

        return [...document.querySelectorAll(defaultSelector)].at(-1) || `form[action*="/cart/add"]:not([id*="product-form-installment-template"], .payment-terms), .button-product-buy_buttons.button-product form[action*="/cart/add"]`;
    }

    const handleConflictEventClick = () => {
        const allEmbedSelectBtn = document.querySelectorAll(".salepify-embed-widget__container button");
        allEmbedSelectBtn.forEach(button => {
            const original = button.onclick;
            button.onclick = null;
            button.addEventListener('click', function (e) {
                e.stopImmediatePropagation();
                e.preventDefault();

                original.call(this, e);
            }, true);
        })
    }
    
    Object.defineProperty(window, "tlFreeGiftOffer", {
        get() {
            return tlFreeGiftOfferClone;
        },
        set(val) {
            if (val && !tlFreeGiftOfferClone) {
                tlFreeGiftOfferClone = val;
                Object.defineProperty(val, "embedWidget", {
                    get() {
                        return embedWidgetClone;
                    },
                    set(newValue) {
                        if (newValue && !embedWidgetClone) {
                            newValue.checkIfPopupEnabled = () => false
                            newValue.isPopupEnabled = false;

                            newValue.targetElements = [getTargetEl()];
                            newValue.updateWidget = async(keys) => {
                                if (window.tlFreeGiftOffer.embedWidget.isFirstLoading) {
                                    window.tlFreeGiftOffer.embedWidget.isPendingRender = true;
                                    return;
                                }

                                const { parentInCart } = await window.tlFreeGiftOffer.getCustomerBuy(window.tlFreeGiftOffer.embedWidget.displayRule);
                                window.tlFreeGiftOffer.embedWidget.parentsInCart = new Map(parentInCart.map((item) => [item.id, item]));

                                const updaters = {
                                    upsellMessage: (state) => window.tlFreeGiftOffer.embedWidget.updateUpsellMessage(state),
                                    progressBar: (state) => window.tlFreeGiftOffer.embedWidget.updateEmbedWidgetProgressBar(state),
                                    selectionHint: (state) => window.tlFreeGiftOffer.embedWidget.updateSelectionHint(state),
                                    claimButton: (state) => window.tlFreeGiftOffer.embedWidget.updateClaimButton(state),
                                    giftsSelectionControl: (state) => window.tlFreeGiftOffer.embedWidget.targetElements.forEach((_, i) => window.tlFreeGiftOffer.embedWidget.updateGiftsSelectionControl(i, state)),
                                };

                                const state = window.tlFreeGiftOffer.getRuleState(window.tlFreeGiftOffer.embedWidget.displayRule.id);

                                const keysToUpdate = keys ?? Object.keys(updaters);

                                keysToUpdate.forEach((key) => updaters[key](state));
                                handleConflictEventClick();
                            }

                            newValue.loadMoreGifts = async () => {
                                const { id: ruleId } = window.tlFreeGiftOffer.embedWidget.displayRule;
                                const { is_complete_fetching: isCompleteFetching } = window.tlFreeGiftOffer.ruleIdMapFetchingGiftStatus.get(ruleId) ?? {};

                                const giftSliders = document.querySelectorAll(".salepify-embed-widget__gifts-slider");

                                let gifts = [];
                                if (!isCompleteFetching) {
                                    gifts = await window.tlFreeGiftOffer.embedWidget.fetchGifts();
                                } else if (giftSliders.length) {
                                    const numberOfLoadedElements = giftSliders[0].querySelectorAll(".salepify-embed-widget__gift-item").length;
                                    const fetchedGifts = window.tlFreeGiftOffer.ruleIdMapFetchedGifts.get(ruleId) ?? [];

                                    if (numberOfLoadedElements < fetchedGifts.length) {
                                        gifts = fetchedGifts.splice(numberOfLoadedElements);
                                    }
                                }

                                if (!gifts.length) return;

                                const giftsHTML = window.tlFreeGiftOffer.embedWidget.getGiftsHTML(gifts);
                                giftSliders.forEach((el) => el.insertAdjacentHTML("beforeend", giftsHTML));
                                handleConflictEventClick();
                            }

                            embedWidgetClone = newValue;
                        }
                    },
                    configurable: true
                });
            }
        },
        configurable: true
    });
})();

// document.addEventListener("DOMContentLoaded", function() {
//     const attachV2 = () => {
//         const embedWidget = document.querySelector('.salepify-embed-widget__container');
//         const gpAddToCartButtons = document.querySelectorAll('gp-product-button.gp-product-button');

//         if (embedWidget && gpAddToCartButtons.length >= 2) {
//             const targetButton = gpAddToCartButtons[1]; 
            
//             targetButton.insertAdjacentElement('afterend', embedWidget);
            
//             const sliderButtons = embedWidget.querySelectorAll('.salepify-embed-widget__slider-button');
//             sliderButtons.forEach(btn => {
//                 btn.setAttribute('type', 'button'); 
//             });
            
//             return true;
//         }
//         return false;
//     };

//     const observer = new MutationObserver((mutationsList, observer) => {
//         if (attachV2()) {
//             observer.disconnect(); 
//         }
//     });

//     observer.observe(document.body, { childList: true, subtree: true });

//     setTimeout(() => {
//         if (attachV2()) {
//             observer.disconnect();
//         }
//     }, 1500);
// });
